import pluralize from 'pluralize';
import ResponsiveVideo from './shared/ResponsiveVideo';

export default function VideoGallery({videos}) {
  const videoUrls = videos.filter((url) => url?.length > 10);

  return (
    <div className="video-gallery">
      <h4>{pluralize("Video", videoUrls.length)}</h4>
      {videoUrls.map((url) => (
        <div key={url} className="video">
          <ResponsiveVideo src={url}/>
        </div>
      ))}
    </div>
  );
}
